export default __webpack_public_path__ + "static/blog-404-world-mobile-0318a49e5112a64592ad76f03130d0b4.png";